import {BaseSearchDTO} from "../baseSearchDTO.interface";

export interface AdvertNoteSearchDTO extends BaseSearchDTO {

}
